"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    marginTop: '6px',
    marginBottom: '6px'
  }
}));

const OptionsDropdown = ({
  children,
  expanded,
  onCollapse,
  anchorEl,
  placement = "bottom-end"
}) => {
  const classes = useStyles();
  return _react.default.createElement(_Popper.default, {
    open: expanded,
    style: {
      zIndex: 2000
    },
    role: undefined,
    transition: true,
    anchorEl: anchorEl,
    placement: placement
  }, _react.default.createElement(_ClickAwayListener.default, {
    onClickAway: onCollapse
  }, _react.default.createElement(_Paper.default, {
    elevation: 16,
    square: true,
    className: classes.root,
    "aria-expanded": expanded
  }, children)));
};

var _default = OptionsDropdown;
exports.default = _default;
module.exports = exports.default;